<template>
  <div>

    <el-row :gutter="15">
      <el-col :span="24" :lg="12">
        <el-card>
          <template slot="header">Osnovne informacije</template>
          <div style="display: flex; border-bottom: 1px dashed #eeeeee; margin: 0px; padding: 5px 0px">
            <div style="flex: auto;">Ime projekta</div>
            <div style="text-align: right;">{{ project.name }}</div>
          </div>
          <div style="display: flex; border-bottom: 1px dashed #eeeeee; margin: 0px; padding: 5px 0px">
            <div style="flex: auto;">ID projekta</div>
            <div style="text-align: right;">13461kj56216b25v32hj2316hj2</div>
          </div>
          <div style="display: flex; border-bottom: 1px dashed #eeeeee; margin: 0px; padding: 5px 0px">
            <div style="flex: auto;">Status</div>
            <div style="text-align: right; color:green; font-weight: bold;">omogočen</div>
          </div>
          <div style=" margin: 0px; margin-top: 5px; padding: 5px 0px">
            <div style="text-align: right; color:green; font-weight: bold;">
              <el-button type="danger" size="mini">Izbriši projekt</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="24" :lg="12" :style="`margin-top:${marginTopOnBreakpoint}px;`">
        <el-card class="naroceneStoritveCard">
          <template slot="header">
            <div style="display: flex">
              <div style="flex:auto; margin: auto;">Naročene storitve</div>
              <div style="margin: auto;">
                <i
                  :class="`${editServicesIcon} naroceneStoritveChangeIcon`"
                  style="font-size: 22px;"
                  @click="editServices = !editServices"
                ></i>
              </div>
            </div>
          </template>
          <div style="display:flex; border-bottom: 1px dashed #eeeeee; margin: 0px; padding: 5px 0px;">
            <div style=" flex:auto;padding-top: 3px ; min-height: 28px;">Osnovni paket</div>
            <div style="text-align: right;padding-top: 3px ; min-height: 28px;" v-if="!editServices">{{prop1}}
              kos
            </div>
            <div style="text-align: right;" v-if="editServices">
              <el-input-number size="mini" v-model="prop1" style="width: 100px;"></el-input-number>
              kos
            </div>
          </div>
          <div style="display:flex; border-bottom: 1px dashed #eeeeee; margin: 0px; padding: 5px 0px;">
            <div style=" flex:auto;padding-top: 3px ; min-height: 28px;">CPU</div>
            <div style="text-align: right;padding-top: 3px ; min-height: 28px;" v-if="!editServices">{{prop2}}
              kos
            </div>
            <div style="text-align: right;" v-if="editServices">
              <el-input-number size="mini" v-model="prop2" style="width: 100px;"></el-input-number>
              kos
            </div>
          </div>
          <div style="display:flex; border-bottom: 1px dashed #eeeeee; margin: 0px; padding: 5px 0px;">
            <div style=" flex:auto;padding-top: 3px ; min-height: 28px;">RAM</div>
            <div style="text-align: right;padding-top: 3px ; min-height: 28px;" v-if="!editServices">{{prop3}}
              GB
            </div>
            <div style="text-align: right;" v-if="editServices">
              <el-input-number size="mini" v-model="prop3" style="width: 100px;"></el-input-number>
              GB
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import {Card, Col, Row, Button, InputNumber} from 'element-ui'
import {CloudProject} from '../../../../../assets/js/T2Cloud/CloudProject'

export default {
  name: 'CloudProjectEdit',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Card.name]: Card,
    [Button.name]: Button,
    [InputNumber.name]: InputNumber
  },
  props: {
    project: {
      type: CloudProject,
      required: true
    }
  },
  data () {
    return {
      editServices: false,
      prop1: 1,
      prop2: 1,
      prop3: 1
    }
  },
  computed: {
    marginTopOnBreakpoint () {
      if (this.$screen.breakpoint === 'xl') {
        return 0
      }
      return 20
    },
    editServicesIcon () {
      return this.editServices ? 'el-icon-check' : 'el-icon-edit'
    }
  }
}
</script>

<style>
.naroceneStoritveCard > div.el-card__header {
  padding: 16px 20px;
}
</style>

<style scoped>
.naroceneStoritveChangeIcon:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/T2Cloud/CloudProjectEdit.vue